const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    // vehicle_ids: {
    //   type: 'string',
    //   title: 'vehicle',
    // },
    show_tonnage: {
      type: 'boolean',
      title: 'tonnage',
    },
    show_hours: {
      type: 'boolean',
      title: 'total_houre',
    },
    show_activity_type: {
      type: 'boolean',
      default: true,
      title: 'task_type',
    },
    show_operation_type: {
      type: 'boolean',
      default: true,
      title: 'operation_type',
    },
    show_supervisor: {
      type: 'boolean',
      default: true,
      title: 'supervisor',
    },
    show_shift_type: {
      type: 'boolean',
      title: 'shift_type',
    },
    show_description: {
      type: 'boolean',
      title: 'description',
    },
    show_cost: {
      type: 'boolean',
      title: 'cost',
    },
  },
});

export default schema;
